export const SET_SITE_CONFIG_DATA = "SET_SITE_CONFIG_DATA";
export const SET_SITE_CONFIG_LOADING = "SET_SITE_CONFIG_LOADING";
export const SET_SITE_CONFIG_PAGINATION = "SET_SITE_CONFIG_PAGINATION";
export const SET_SITE_CONFIG_FILTER = "SET_SITE_CONFIG_FILTER";
export const SET_SITE_CONFIG_SINGLE = "SET_SITE_CONFIG_SINGLE";
export const RESET_SITE_CONFIG_REDUCER = "RESET_SITE_CONFIG_REDUCER";